import * as React from 'react';
import { Edit } from 'react-admin';
import { JobForm, JobTitle } from './commons';
import JobShow from './JobShow';
import { transformRecord } from './utils';

const JobEdit = () => (
    <Edit title={<JobTitle />} transform={transformRecord} mutationMode="pessimistic" redirect={false} disableAuthentication>
        <>
            <JobForm />
            <JobShow />
        </>
    </Edit >
);

export default JobEdit;
